import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";

const routes = [
    {
        path: '',
        component: () => import('@/views/LogIn.vue'),
        name: 'login',
    },
    {
        path: '/service_monitoring',
        component: () => import('@/views/ServiceMonitoringSummary'),
        name: 'service_monitoring',
    },
    {
        path: '/service_monitoring/edit',
        component: () => import('@/views/ServiceMonitoringEdit'),
        name: 'service_monitoring-edit',
    },
    {
        path: '/service_monitoring/logs/:stack_name/:service_name',
        props: true,
        component: () => import('@/views/ServiceMonitoringLogs'),
        name: 'service_monitoring-logs',
    },
    {
        path: '/service_monitoring/failures/:stack_name/:service_name',
        props: true,
        component: () => import('@/views/ServiceMonitoringFailures'),
        name: 'service_monitoring-failures',
    }
]

export const history = createWebHistory();

const router = createRouter({history, routes});

export default router;
